<div class="pair-display" (click)="onPairClick()">
  <div class="result-icon" *ngIf="showIcon">
    <mat-icon>fiber_smart_record</mat-icon>
  </div>
  <div class="result-content">
    <div class="result-header">
      <ddc-country-flag [ddc_lng]="result.info?.language_1" [has_label]="false"></ddc-country-flag>
      <ddc-country-flag [ddc_lng]="result.info?.language_2" [has_label]="false"></ddc-country-flag>
      <span class="vertical-separator" *ngIf="result.info?.language_1 && result.info?.language_2"> | </span>

      <div class="word-item">
        <span class="article" *ngIf="result.info?.article_1">{{ result.info.article_1 }}</span>
        <span class="word-label" [innerHTML]="result.info?.word_1 || result.label.split(' - ')[0]"></span>
        <span class="part-of-speech" *ngIf="result.info?.part_of_speech_1">[{{ result.info.part_of_speech_1 }}]</span>
      </div>

      <span class="pair-separator"> ↔ </span>

      <div class="word-item">
        <span class="article" *ngIf="result.info?.article_2">{{ result.info.article_2 }}</span>
        <span class="word-label" [innerHTML]="result.info?.word_2 || result.label.split(' - ')[1]"></span>
        <span class="part-of-speech" *ngIf="result.info?.part_of_speech_2">[{{ result.info.part_of_speech_2 }}]</span>
      </div>
    </div>
  </div>
</div>
